import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { Action, ListRow, ListItem, TitleCell } from '@gandi/ui/deprecated';
import OfflinePayment from './NextSteps/OfflinePayment';
import OrderStatus from './OrderStatus';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PrepaidRefill({
  offlineMean,
  prepaidBalance,
  order,
  adminURL,
  sharingId
}) {
  const translator = useTranslator();
  const {
    __,
    formatPrice
  } = translator;
  const done = order.status === 'done';
  const pending = !done && !offlineMean;
  const amount = translator.formatPrice(order.price_after_taxes, order.currency);
  const validBalance = typeof prepaidBalance === 'number' && !Number.isNaN(prepaidBalance);
  let newBalance = 0;
  if (validBalance) {
    newBalance = prepaidBalance + order.price_after_taxes;
  }
  const title = done ? __('The prepaid account has been refilled') : __('We are now providing the prepaid account with %(amount)s', {
    amount
  });
  const icon = 'success';
  const theme = 'success';
  return /*#__PURE__*/_jsxs(Base, {
    marginBottom: "small",
    tagName: "section",
    className: "wrapper-md",
    children: [offlineMean ? /*#__PURE__*/_jsx(OrderStatus, {
      order: order,
      adminURL: adminURL
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ListRow, {
        separatorBottom: true,
        children: /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(TitleCell, {
            icon: icon,
            iconTheme: theme,
            children: title
          })
        })
      }), /*#__PURE__*/_jsxs(Base, {
        padding: "small",
        backgroundColor: "surface",
        children: [done && validBalance && /*#__PURE__*/_jsx(Base, {
          tagName: "p",
          margin: "none",
          dangerouslySetInnerHTML: __('The prepaid balance is now <strong>%(balance)s</strong>.', {
            withHTML: true,
            balance: formatPrice(prepaidBalance, order.currency)
          })
        }), pending && /*#__PURE__*/_jsxs(Base, {
          tagName: "p",
          margin: "none",
          children: [__('This operation can take a few minutes depending of the bank or payment method.'), validBalance && /*#__PURE__*/_jsx("br", {}), validBalance && /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: __('Once ended, the balance credit will be %(newBalance)s', {
              withHTML: true,
              newBalance: formatPrice(newBalance, order.currency)
            })
          })]
        }), (done || pending) && /*#__PURE__*/_jsx(Base, {
          tagName: "p",
          margin: "none",
          children: __('If you had orders or payments awaiting for a prepaid refill, we will run them automatically.')
        })]
      })]
    }), (done || pending) && /*#__PURE__*/_jsx(Action, {
      variant: "block",
      icon: "arrowRight",
      to: "/overview",
      separatorTop: true,
      children: __('View orders awaiting')
    }), (done || pending) && /*#__PURE__*/_jsxs(Base, {
      backgroundColor: "surface",
      padding: "small",
      marginTop: "base",
      flex: true,
      flexJustifyBetween: true,
      children: [/*#__PURE__*/_jsx("span", {
        children: __('Transaction number')
      }), /*#__PURE__*/_jsx("a", {
        href: `${adminURL}/billing/${sharingId}/orders/${order.id}`,
        children: order.id
      })]
    }), !done && offlineMean && /*#__PURE__*/_jsx(OfflinePayment, {
      order: order
    })]
  });
}